<template>
  <div class="personal-view">
    <!-- <p class="navigation-text">
      最新上架
    </p> -->
    <div class="content">
      <div class="right-middle">
        <div class="data-view">
          <ul>
            <li v-for="(item,index) in dataList" :key="index">
              <div class="img-d" @click="goDetails(item.id)">
                <img :src="item.imgUrl" alt="">
              </div>
              <div class="content-d">
                <p class="p-name" v-html="item.name"></p>
                <p class="p-money">
                  ￥{{item.promotionPrice ? item.promotionPrice : item.money}}
                  <span v-show="item.promotionPrice">
                    定价：￥{{item.money}}
                  </span>
                </p>
                <p class="p-eBookPrice">
                  <span v-show="item.eBookPrice">
                    电子书:￥
                    {{item.paperPromotionPrice ? item.paperPromotionPrice : item.eBookPrice}}
                    <span style="text-decoration: line-through" v-show="item.paperPromotionPrice">
                      定价：{{item.eBookPrice}}
                    </span>
                  </span>
                </p>
                <p class="p-eBookPrice" v-html="item.author"></p>
                <el-rate
                  class="star"
                  v-model="item.star"
                  disabled
                  show-score
                  text-color="red"
                  score-template="{value}颗星">
                </el-rate>
                <div class="d-describe" v-html="item.describe"></div>
                <p class="p-btns">
                  <button @click="trialReading(item)">在线试读</button>
                  <img
                    @click="shoppingCart(item)"
                    :src="item.isGwc ? gwc2 : gwc1"
                    alt=""
                    :class="item.isGwc ? 'imgActive' : ''">
                  <img @click="collection(item)" :src="item.isSc ? star2 : star1" alt="">
                </p>
              </div>
            </li>
          </ul>
          <div class="pagination">
            <el-pagination
              background
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="pageSize"
              layout="prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Menu from '@/base/menu/menu'
import SidebarTwo from '@/base/sidebar2/sidebar2'
import NavMenu from '@/base/navmenu/navmenu'
export default {
  name: '',
  components: {
    'menu-list': Menu,
    'sidebar-two': SidebarTwo,
    'nav-menu': NavMenu
  },
  data () {
    return {
      currentPage: 1,
      total: 0,
      pageSize: 10,
      gwc1: require('@/assets/images/fl/gwc1.png'),
      gwc2: require('@/assets/images/fl/gwc2.png'),
      star1: require('@/assets/images/fl/star1.png'),
      star2: require('@/assets/images/fl/star2.png'),
      dataList: []
    }
  },
  methods: {
    trialReading (item) { // 在线试读
      if (item.eBookPrice) {
        let routeData = this.$router.resolve({
          name: 'Book',
          query: {
            bookId: item.id,
            type: 1
          }
        })
        window.open(routeData.href, '_blank')
        // window.open('http://localhost:8080/#/book?bookId=' + item.id)
      } else {
        alert('该书籍没有电子书')
      }
    },
    shoppingCart (item) { // 购物车
      const state = item.isGwc
      const userId = this.$store.state.userMsg.id
      if (!userId) {
        this.$router.push({
          name: 'Login'
        })
      } else {
        if (!state) {
          const bookId = item.id
          const par = `?bookId=${bookId}&userId=${userId}&type=0`
          const bookPrice = item.eBookPrice
          this.$get(this.$allUrl.addCart + par).then(res => {
            if (res.code === '0') {
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              item.isGwc = true
              this.$root.eventHub.$emit('update_shoppingNum')
            } else {
              this.$message.error('添加失败')
            }
          })
          if (bookPrice) {
            const par2 = `?bookId=${bookId}&userId=${userId}&type=1`
            this.$get(this.$allUrl.addCart + par2).then(res => {
              if (res.code !== '0') {
                this.$message.error('电子书加入购物车失败')
              } else {
                this.$root.eventHub.$emit('update_shoppingNum')
              }
            })
          }
        }
      }
    },
    collection (item) { // 收藏
      const userId = this.$store.state.userMsg.id
      if (!userId) {
        this.$router.push({
          name: 'Login'
        })
      } else {
        if (!item.isSc) {
          const bookId = item.id
          const par = `?bookId=${bookId}&userId=${userId}`
          this.$get(this.$allUrl.addFavorite + par).then(res => {
            if (res.code === '0') {
              this.$notify({
                title: '成功',
                message: '已成功收藏',
                type: 'success',
                showClose: false,
                duration: 1500
              })
              item.isSc = true
            } else {
              this.$message.error(res.message)
            }
          })
        }
      }
    },
    handleCurrentChange (val) { // 分页
      const start = (val - 1) * this.pageSize
      this.getNewShelfBooks(start)
    },
    getNewShelfBooks (start) { // 获取最新特价数据
      const userId = this.$store.state.userMsg.id
      const pageSize = this.pageSize
      const par = userId ? `?start=${start}&num=${pageSize}&userId=${userId}` : `?start=${start}&num=${pageSize}`
      this.$get(this.$allUrl.getNewShelfBooks + par).then(res => {
        if (res.code === '0') {
          const list = res.data
          this.total = res.recordsTotal
          this.dataList = []
          const imgAdmin = this.$allUrl.imgAdmin
          list.forEach(e => {
            this.dataList.push({
              id: e.bookId,
              imgUrl: imgAdmin + e.coverUrl,
              name: e.bookName,
              author: e.bookAuthors,
              money: e.paperPrice,
              eBookPrice: e.emark === 0 ? '' : e.bookPrice,
              star: e.starLevel,
              describe: e.bookSummary,
              isGwc: false,
              isSc: e.favorite !== null,
              promotionPrice: e.promotionPrice,
              paperPromotionPrice: e.paperPromotionPrice
            })
          })
        }
      })
    },
    goDetails (id) {
      this.$router.push({
        name: 'GoodsDetails',
        query: {
          id: id
        }
      })
    }
  },
  mounted () {
    this.getNewShelfBooks(0)
  }
}
</script>
<style lang="less" scoped>
  .personal-view{
    .menu{
      margin: 20px auto;
      width: 600px;
    }
    .navigation-text{
      padding: 40px 0 10px 0;
      margin: 0;
      border-bottom: 1px solid #DDDDDD;
      color: #7C76A4;
      font-size: 16px;
    }
    .content{
      display: flex;
      .left-nav{
        width: 200px;
      }
      .right-middle{
        flex: 1;
        // margin-left: 20px;
        .search-criteria{
          background: #EDEDEE;
          ul{
            list-style: none;
            padding: 0 10px;
            margin: 0;
            margin-top: 20px;
            font-size: 14px;
            border: 1px solid #dddddd;
            li:last-child{
              border: 0;
            }
            li{
              display: flex;
              line-height: 30px;
              border-bottom: 1px dashed #d2c7c7;
              .left-title{
                width: 60px;
                color: #666666;
              }
              .right-val{
                display: flex;
                border: 0;
                margin: 0;
                li{
                  width: 70px;
                  color: #999999;
                  border: 0;
                  span{
                    cursor: pointer;
                  }
                  .spanActive{
                    color: #990000;
                  }
                }
              }
            }
          }
        }
        .data-view{
          // margin-top: 20px;
          ul{
            list-style: none;
            padding: 0;
            margin: 0;
            display: flex;
            flex-wrap: wrap;
            li{
              width: 50%;
              display: flex;
              padding: 0 0 20px 0;
              border-bottom: 1px solid #DDDDDD;
              .img-d{
                font-size: 0;
                padding-left: 60px;
                padding-top: 30px;
                img{
                  width: 137px;
                  height: 196px;
                  display: block;
                }
              }
              .content-d{
                padding-left: 15px;
                padding-top: 20px;
                flex: 1;
                padding-right: 60px;
                font-size: 14px;
                overflow: hidden;
                p{
                  padding: 10px 0 0 0;
                  margin: 0;
                }
                .p-name{
                  color: #35353b;
                  font-size: 16px;
                  padding-top: 0;
                  overflow: hidden;
                  text-overflow:ellipsis;
                  white-space: nowrap;
                }
                .p-money{
                  color: #de0024;
                  font-weight: 600;
                  font-size: 16px;
                  span{
                    font-weight: 200;
                    text-decoration: line-through;
                    color: #A2A2A2;
                    font-size: 14px;
                  }
                }
                .p-eBookPrice{
                  color: #A2A2A2;
                  height: 19px;
                }
                .star{
                  margin-top: 10px;
                }
                .d-describe{
                  height: 37px;
                  margin-top: 10px;
                  overflow: hidden;
                  word-break: break-all;
                  display: -moz-box;
                  -moz-box-orient:vertical;
                  display: -webkit-box;
                  -webkit-box-orient:vertical;
                  text-overflow: ellipsis;
                  -webkit-line-clamp: 2;
                }
                .p-btns{
                  vertical-align: middle;
                  button{
                    width: 100px;
                    height: 28px;
                    background-color: #B7151E;
                    color: white;
                    outline: none;
                    border: 0;
                    border-radius: 6px;
                    cursor: pointer;
                    float: left;
                  }
                  img{
                    padding: 0 10px;
                    cursor: pointer;
                  }
                  .imgActive{
                    cursor: auto;
                  }
                }
              }
            }
          }
          .pagination{
            text-align: right;
            padding: 50px 0;
          }
        }
      }
    }
  }
</style>
<style>
.el-pagination.is-background .el-pager li:not(.disabled).active{
    background: #B7151E !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/SpecialOffer/newUp.vue


// WEBPACK FOOTER //
// src/components/SpecialOffer/newUp.vue